/*
 * @Description: 路由
 * @Author: Xiaochun liu
 * @Date: 2023-08-22 11:43:42
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2025-08-06 18:42:44
 */
import { RouteNames } from './constant'

import MainLayout from '@/components/Layout/MainLayout.vue'
const IndexHomeView = () => import('@/features/index-home/index.vue') // 首页

const HomeView = () => import('@/features/home/views/HomeView.vue') // 首页
const ModeView = () => import('@/features/inspiration/views/ModeView.vue') // 数智灵感箱
// const WorkbenchView = () => import('@/features/workbench/views/WorkbenchView.vue') // 工作台
const ProductManageView = () => import('@/features/workbench/views/ProductManageView.vue') // 工作台 > 提案管理
const ProductDetailMainView = () => import('@/features/workbench/views/ProductDetailMainView.vue') // 工作台 > 产品详情
const ProductDetailView = () => import('@/features/workbench/views/ProductDetailView.vue') // 工作台 > 产品方案详情
const ProposalDetailView = () => import('@/features/workbench/views/ProposalDetailView.vue') // 工作台 > 提案详情
const ProductInformationView = () => import('@/features/workbench/views/ProductInformationView.vue') // 工作台 > 产品资料
const ProductIntelligenceView = () => import('@/features/workbench/views/ProductIntelligence.vue') // 工作台 > 产品情报
const SelectProductView = () => import('@/features/validation/views/SelectProductView.vue') // 提案验证 > 方案验证
// const SelectKnowledgeView = () => import('@/features/validation/views/SelectKnowledgeView.vue') // 提案验证 > 选择产品 > 选择知识库
// const ValidateResultView = () => import('@/features/validation/views/ValidateResultView.vue') // 提案验证 > 选择产品 > 选择知识库 > 验证结果
// const CreateProductView = () => import('@/features/workbench/views/CreateProductView.vue') // 产品详情 > 提案工作台(无侧边栏)
const ProductDynamicView = () => import('@/features/workbench/views/ProductDynamicView.vue') // 产品详情 > 产品动态
const PersonalCenterBasicInfoView = () => import('@/features/personal-center/views/BasicInfoView.vue') // 个人中心 > 基础信息
const PersonalCenterEnergyPointInfoView = () => import('@/features/personal-center/views/EnergyPointInfoView.vue') // 个人中心 > 能量点明细
const PersonalCenterExchangeEnergyPointView = () => import('@/features/personal-center/views/ExchangeEnergyPointView.vue') // 个人中心 > 兑换能量点
const PersonalCenterCompanyManagementView = () => import('@/features/personal-center/views/company/CompanyManagementView.vue') // 个人中心 > 企业管理
const PersonalCenterCompanyProductMembersView = () => import('@/features/personal-center/views/company/CompanyProductMembersView.vue') // 个人中心 > 企业商品成员管理
// const CompanyInvitationView = () => import('@/features/personal-center/views/CompanyInvitationView.vue') // 个人中心 > 邀请中间页
const PersonalCenterView = () => import('@/features/personal-center/views/PersonalCenterView.vue') // 个人中心
const KnowledgeBaseView = () => import('@/features/knowledgeBase/views/KnowledgeBaseView.vue') // 知识库
// const KnowledgeBaseIndexView = () => import('@/features/knowledgeBase/views/KnowledgeBaseIndexView.vue') // 知识库首页
// const KnowledgeBaseAliView = () => import('@/features/knowledgeBase/views/KnowledgeBaseAliView.vue') // 知识库 > 阿里数据库
// const KnowledgeBaseUserView = () => import('@/features/knowledgeBase/views/KnowledgeBaseUserView.vue') // 知识库 > 用户共享知识库
// const KnowledgeBaseTableView = () => import('@/features/knowledgeBase/views/KnowledgeBaseTableView.vue') // 知识库 > 表格
const AssPage = () => import('@/features/ass-page/index.vue') // 助手落地页
const NotifyView = () => import('@/features/notify/index.vue') // 消息列表

const AppIntroduction = () => import('@/features/introduction/app/index.vue') // 数美链App应用介绍
const ProductProcessSolutionIntroduction = () => import('@/features/introduction/product-process-solution/index.vue') // 产品流程解决方案介绍

const ProposalView = () => import('@/features/workbench/views/ProposalView.vue') // 提案工作台(有侧边栏)
const ProposalSquare = () => import('@/features/proposal-square/index.vue') // 提案广场
const SquareProposalDetail = () => import('@/features/proposal-square/detail.vue') // 提案广场详情

const InspirationLibrary = () => import('@/features/inspiration-library/index/index.vue') // 企业灵感库
const InspirationLibraryDetail = () => import('@/features/inspiration-library/detail/index.vue') // 企业灵感库 - 详情页

const DataSystem = () => import('@/features/data-system/index.vue') // 数据洞察中心
const AiAssistantQa = () => import('@/features/ai-assistant/ai-qa.vue') // AI助手 - 问答
const AiAssistantFind = () => import('@/features/ai-assistant/ai-find.vue') // AI助手 - 找资料
const AiAssistantMaterial = () => import('@/features/ai-assistant/ai-material.vue') // AI助手 - 材料
const DataResourceCollection = () => import('@/features/data-resource-collection/index.vue') // 资源链接中心
const NoWorkspaceView = () => import('@/features/no-workspace/NoWorkspaceView.vue') // 申请团队空间(无空间/空间审核中)

const CustomerProposal = () => import('@/features/customer-proposal/views/index.vue') // 客户提案
const CustomerProposalArchive = () => import('@/features/customer-proposal/views/company-archive.vue') // 客户提案 - 公司资料
const CustomerProposalDetail = () => import('@/features/customer-proposal/views/detail.vue') // 客户提案详情
const CustomerProposalPpt = () => import('@/features/customer-proposal/views/proposal-ppt.vue') // 客户提案详情
const ProposalLibrary = () => import('@/features/proposal-library/index.vue') // 提案库
const ProposalLibraryFileDetail = () => import('@/features/proposal-library/file-detail.vue') // 提案库-文件详情
const MarketAgentAnalysis = () => import('@/features/ai-agent/pages/analysis.vue') // 市场Agent多维分析

export const protectedPaths = [
  {
    path: '/index-home', // 首页
    name: 'IndexHomeView',
    component: IndexHomeView,
    meta: { title: '首页', posthogTitle: '首页' },
  },
  {
    path: '/data-system',
    name: 'DataSystem',
    component: DataSystem,
    meta: { title: '数据洞察中心', posthogTitle: '数据洞察中心' },
  },
  {
    path: '/data-resource-collection',
    name: 'DataResourceCollection',
    component: DataResourceCollection,
    meta: { title: '资源链接中心', posthogTitle: '资源链接中心' },
  },
  {
    path: '/ai-assistant/qa',
    name: 'AiAssistantQa',
    component: AiAssistantQa,
    meta: { title: 'AI助手 - 问答', posthogTitle: 'AI助手 - 问答' },
  },
  {
    path: '/ai-assistant/find',
    name: 'AiAssistantFind',
    component: AiAssistantFind,
    meta: { title: 'AI助手 - 找资料', posthogTitle: 'AI助手 - 找资料' },
  },
  {
    path: '/ai-assistant/material',
    name: 'AiAssistantMaterial',
    component: AiAssistantMaterial,
    meta: { title: 'AI助手 - 材料', posthogTitle: 'AI助手 - 材料' },
  },
  {
    path: '/inspiration/design',
    name: 'ModeView',
    component: ModeView,
    meta: { title: 'AI一键提案', posthogTitle: 'AI一键提案' },
  },
  {
    path: '/', // 首页
    redirect: '/workbench',
  },
  // {
  //   path: '/workbench', // 首页
  //   name: 'WorkbenchView',
  //   component: HomeView,
  //   meta: {
  //     title: '首页',
  //     posthogTitle: '首页',
  //   },
  // },
  {
    path: '/workbench', // 首页
    name: 'WorkbenchView',
    component: IndexHomeView,
    meta: {
      title: '首页',
      posthogTitle: '首页',
    },
  },
  // {
  //   path: '/home', // 首页
  //   name: 'HomeView',
  //   component: HomeView,
  //   meta: { title: '首页', posthogTitle: '首页' },
  // },
  {
    path: '/productManage', // 提案管理
    name: 'ProductManageView',
    component: ProductManageView,
    meta: {
      title: '提案管理',
      posthogTitle: '提案管理',
    },
  },
  {
    path: '/productDetailMain',
    name: 'ProductDetailMainView',
    component: ProductDetailMainView,
    meta: { title: '提案管理详情', posthogTitle: '提案管理详情' },
    redirect: '/productDetailMain/productDetail?archiveId=0',
    children: [
      {
        path: 'productDetail', // 工作台 > 产品详情
        name: 'ProductDetailView',
        component: ProductDetailView,
        meta: { title: '提案管理详情', posthogTitle: '产品方案' },
      },
      {
        path: 'proposalDetail', // 工作台 > 提案详情
        name: 'ProposalDetailView',
        component: ProposalDetailView,
        meta: { title: '提案管理详情', posthogTitle: '产品验证' },
      },
      {
        path: 'productInformation', // 工作台 > 产品资料
        name: 'ProductInformationView',
        component: ProductInformationView,
        meta: { title: '提案管理详情', posthogTitle: '产品资料' },
      },
      {
        path: 'productIntelligence', // 工作台 > 产品情报
        name: 'ProductIntelligenceView',
        component: ProductIntelligenceView,
        meta: { title: '提案管理详情', posthogTitle: '产品情报' },
      },
      {
        path: 'productDynamic', // 产品动态
        name: 'ProductDynamicView',
        component: ProductDynamicView,
        meta: { title: '提案管理详情', posthogTitle: '产品动态' },
      },
    ],
  },
  {
    path: '/selectProduct', // 提案验证 > 方案验证
    name: 'SelectProductView',
    component: SelectProductView,
    meta: { title: '方案验证', posthogTitle: '方案验证' },
  },
  // {
  //   path: '/selectKnowledge/:id', // 提案验证 > 选择产品 > 选择知识库
  //   name: 'SelectKnowledgeView',
  //   component: SelectKnowledgeView,
  //   meta: { title: '方案验证', posthogTitle: '方案验证(选择知识库)' },
  // },
  // {
  //   path: '/validateResult/:id', // 提案验证 > 选择产品 > 选择知识库 > 验证结果
  //   name: 'ValidateResultView',
  //   component: ValidateResultView,
  //   meta: { title: '方案验证', posthogTitle: 'AI提案验证详情' },
  // },
  // {
  //   path: '/company-invitation',
  //   name: 'CompanyInvitationView',
  //   component: CompanyInvitationView,
  //   meta: { title: '企业邀请', posthogTitle: '企业邀请中间页' },
  // },
  {
    path: '/personal-center', // 个人中心
    name: 'PersonalCenterView',
    component: PersonalCenterView,
    meta: { title: '个人中心', posthogTitle: '个人中心' },
    redirect: '/personal-center/basic-info',
    children: [
      {
        path: 'basic-info',
        name: 'PersonalCenterBasicInfoView',
        component: PersonalCenterBasicInfoView,
        meta: { title: '个人中心', posthogTitle: '基础信息' },
      },
      {
        path: 'energy-point-info',
        name: 'PersonalCenterEnergyPointInfoView',
        component: PersonalCenterEnergyPointInfoView,
        meta: { title: '个人中心', posthogTitle: '能量点明细' },
      },
      {
        path: 'exchange-energy-point',
        name: 'PersonalCenterExchangeEnergyPointView',
        component: PersonalCenterExchangeEnergyPointView,
        meta: { title: '个人中心', posthogTitle: '兑换能量点' },
      },
      {
        path: 'company-management',
        name: 'PersonalCenterCompanyManagementView',
        component: PersonalCenterCompanyManagementView,
        meta: { title: '个人中心', posthogTitle: '企业管理' },
      },
      {
        path: 'company-product-member/:id',
        name: 'PersonalCenterCompanyProductMembersView',
        component: PersonalCenterCompanyProductMembersView,
        meta: { title: '个人中心', posthogTitle: '产品成员管理' },
      },
    ],
  },
  {
    path: '/createProduct', // 提案工作台
    name: 'CreateProductView',
    component: ProposalView,
    meta: { title: '提案工作台', posthogTitle: '提案工作台' },
  },
  {
    path: '/proposal-square', // 提案广场
    name: 'ProposalSquare',
    component: ProposalSquare,
    meta: { title: '提案广场', posthogTitle: '提案广场' },
  },
  {
    path: '/square-proposal-detail', // 提案广场详情
    name: 'SquareProposalDetail',
    component: SquareProposalDetail,
    meta: { title: '提案广场详情', posthogTitle: '提案广场详情' },
  },
  {
    path: '/knowledge', // 知识库
    name: 'Knowledge',
    component: () => import('@/features/knowledgeBase/knowledge/index.vue'),
    meta: { title: '知识库', posthogTitle: '知识库' },
  },
  {
    path: '/knowledge-collection', // 知识库收藏
    name: 'KnowledgeCollection',
    component: () => import('@/features/knowledgeBase/collection/index.vue'),
    meta: { title: '知识库收藏', posthogTitle: '知识库收藏' },
  },
  // {
  //   path: '/platform-knowledge', // 平台知识库
  //   name: 'PlatformKnowledge',
  //   component: () => import('@/features/knowledgeBase/platform/index.vue'),
  //   meta: { title: '平台知识库', posthogTitle: '平台知识库' },
  // },
  {
    path: '/platform-knowledge-search', // 平台知识库
    name: 'PlatformKnowledgeSearch',
    component: () => import('@/features/knowledgeBase/platform/search.vue'),
    meta: { title: '平台知识库', posthogTitle: '平台知识库' },
  },
  // {
  //   path: '/platform-knowledge-search', // 平台知识库-搜索
  //   name: 'PlatformKnowledgeSearch',
  //   component: () => import('@/features/knowledgeBase/platform/search.vue'),
  //   meta: { title: '平台知识库-搜索页', posthogTitle: '平台知识库-搜索页' },
  // },
  {
    path: '/knowledgeBase', // 知识库
    name: 'KnowledgeBaseView',
    component: KnowledgeBaseView,
    meta: { title: '知识库', posthogTitle: '知识库' },
  },
  {
    path: '/knowledge/:libId', // 知识库列表
    name: 'KnowledgeFileView',
    component: () => import('@/features/knowledgeBase/views/KnowledgeFileView.vue'),
    meta: { title: '知识库文件列表', posthogTitle: '知识库文件列表' },
  },
  {
    path: '/knowledge-folder/:libId', // 知识库文件夹列表
    name: 'KnowledgeFolderiew',
    component: () => import('@/features/knowledgeBase/views/KnowledgeFolderView.vue'),
    meta: { title: '知识库文件夹列表', posthogTitle: '知识库文件夹列表' },
  },
  {
    path: '/knowledge-infolder/:libId/:folderId', // 知识库文件夹内-文件列表
    name: 'KnowledgeInFolderiew',
    component: () => import('@/features/knowledgeBase/views/KnowledgeInFolderView.vue'),
    meta: { title: '知识库文件夹列表', posthogTitle: '知识库文件夹内-文件列表' },
  },
  {
    path: '/knowledge-file-detail/:fileId', // 知识库文件详情
    name: 'KnowledgeFileDetail',
    component: () => import('@/features/knowledgeBase/views/KnowledgeFileDetailView.vue'),
    meta: { title: '知识库文件详情', posthogTitle: '知识库文件详情' },
  },
  {
    path: '/intelligent-assistant', // 智能助手
    name: RouteNames.ASSISTANT_PAGE,
    component: AssPage,
  },
  {
    path: '/intelligence',
    name: 'IntelligenceCenter',
    component: () => import('@/features/intelligence/views/list.vue'),
    meta: { title: '情报中心', posthogTitle: '情报中心' },
  },
  {
    path: '/intelligence/market/:id',
    name: 'IntelligenceMarketDetail',
    component: () => import('@/features/intelligence/views/market-direction.vue'),
    meta: { title: '市场风向详情', posthogTitle: '市场风向详情' },
  },
  {
    path: '/intelligence/technology/:id',
    name: 'IntelligenceTechnologyDetail',
    component: () => import('@/features/intelligence/views/frontier-technology.vue'),
    meta: { title: '前沿科技详情', posthogTitle: '前沿科技详情' },
  },
  {
    path: '/notify', // 消息列表
    name: 'NotifyView',
    component: NotifyView,
    meta: { title: '消息列表', posthogTitle: '消息列表' },
  },
  {
    path: '/introdution/app', // 数美链APP介绍页
    name: 'AppIntroduction',
    component: AppIntroduction,
    meta: {
      title: '数美链APP介绍页',
      posthogTitle: '数美链APP介绍页',
    },
  },
  {
    path: '/introdution/product-process-solution', // 产品流程解决方案介绍
    name: 'ProductProcessSolutionIntroduction',
    component: ProductProcessSolutionIntroduction,
    meta: {
      title: '产品流程解决方案介绍',
      posthogTitle: '产品流程解决方案介绍',
    },
  },
  {
    path: '/proposal', // 提案工作台
    name: 'ProposalView',
    component: ProposalView,
    meta: { title: '提案工作台', posthogTitle: '提案工作台' },
  },
  {
    path: '/inspiration-library', // 灵感库
    name: 'InspirationLibrary',
    component: InspirationLibrary,
    meta: {
      title: '灵感库',
      posthogTitle: '灵感库',
    },
  },
  {
    path: '/inspiration-library-file/:id', // 灵感文件详情
    name: 'InspirationLibraryDetail',
    component: InspirationLibraryDetail,
    meta: {
      title: '灵感文件详情',
      posthogTitle: '灵感文件详情',
    },
  },
  {
    path: '/market-agent',
    name: 'MarketAgent',
    component: () => import('@/features/ai-agent/pages/index.vue'),
    meta: { title: '市场Agent', posthogTitle: '市场Agent' },
  },
  {
    path: '/market-agent-report/:id',
    name: 'MarketAgentReport',
    component: () => import('@/features/ai-agent/pages/report.vue'),
    meta: { title: '市场Agent报告', posthogTitle: '市场Agent报告' },
  },
  {
    path: '/market-agent-analysis',
    name: 'MarketAgentAnalysis',
    component: MarketAgentAnalysis,
    meta: { title: '市场Agent多维分析', posthogTitle: '市场Agent多维分析' },
  },
  {
    path: '/no-workspace',
    name: 'NoWorkspaceView',
    component: NoWorkspaceView,
    meta: {
      title: '申请团队空间',
      posthogTitle: '申请团队空间',
    },
  },
  {
    path: '/customer-proposal-agent',
    name: 'CustomerProposalAgent',
    component: CustomerProposal,
    meta: {
      title: '客户提案Agent',
      posthogTitle: '客户提案Agent',
    },
  },
  {
    path: '/customer-proposal-detail',
    name: 'CustomerProposalDetail',
    component: CustomerProposalDetail,
    meta: {
      title: '客户提案详情',
      posthogTitle: '客户提案详情',
    },
  },

  {
    path: '/customer-proposal-ppt',
    name: 'CustomerProposalPpt',
    component: CustomerProposalPpt,
    meta: {
      title: '客户提案PPT',
      posthogTitle: '客户提案PPT',
    },
  },
  {
    path: '/customer-proposal-archive',
    name: 'CustomerProposalArchive',
    component: CustomerProposalArchive,
    meta: {
      title: '企业基础资料',
      posthogTitle: '客户提案Agent-企业基础资料',
    },
  },
  {
    path: '/proposal-library',
    name: 'ProposalLibrary',
    component: ProposalLibrary,
    meta: {
      title: '提案库',
      posthogTitle: '提案库',
    },
  },
  {
    path: '/proposal-library/file-detail/:productId',
    name: 'ProposalLibraryFileDetail',
    component: ProposalLibraryFileDetail,
    meta: {
      title: '文件详情',
      posthogTitle: '提案库-文件详情',
    },
  },
]

export const protectedRoutes = [
  {
    path: '/app',
    component: MainLayout,
    children: protectedPaths,
  },
]
